import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useHistory } from 'react-router-dom';
import { Container, Form, Modal } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { ErrorMessage } from '@hookform/error-message';
import Select from 'react-select';
import FormLabel from '../../common/FormLabel';
import FormInput from '../../common/FormInput';
import { passwordStrengthValidator } from '../../../utils/form.utils';
import { getRecaptchaKey } from '../../../utils/config.utils';
import FormPasswordInput from '../../common/FormPasswordInput';
import { displayFormErrorsFromApi } from '../../api/api.display.error';
import LoadButton from '../../common/LoadButton';
import { Row, Col, ProgressBar } from 'react-bootstrap';
import {
  CAMP,
  MY_PARTNER_ROUTE,
  PARTNER_LOGIN,
  PARTNER_ROUTE,
  SCHOOL_LOGIN,
  SCHOOL_ROUTE,
} from '../../../constants/routes.constants';
import { partnerSignUpErrors } from '../../../constants/error.constants';
import { bg } from '../../../constants/component.constants';
import { changeBodyClassName } from '../../../utils/utils';
import { useAuth } from '../../auth/Auth';
import isEmail from 'validator/lib/isEmail';
import '../onboarding/scss/sign.up.scss';
import { schoolViewModel } from './school.view.model';
import { partnerViewModel } from './partner.view.model';
import EmptyHeader from '../../header/EmptyHeader';

const PartnerSignUp = ({ location }) => {
  const _NOT_SELECTED = '';
  const history = useHistory();
  const [show, setShow] = useState(false);
  const [partnerType, setPartnerType] = useState("school");
  const [organizationType, setOrganizationType] = useState("");
  const grecaptchakey = getRecaptchaKey();
  const { setUser } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true);
  const { register, watch, handleSubmit, setError, errors, getValues } = useForm({
    mode: 'onBlur',
  });
  const [errShow, setErrShow] = useState(false);
  const [errMessage, setErrMessage] = useState('');

  const options = [
    { value: _NOT_SELECTED, label: 'Select...' },
    { value: 'school', label: 'Camp Master (Educator)' },
    { value: 'expert', label: 'Expert (individual)' },
    { value: 'partner', label: 'Treehouse (organization for profit / non profit)' },
  ];

  const partnerOptions = [
    { value: _NOT_SELECTED, label: 'Select...' },
    { value: 'profit', label: 'Profit' },
    { value: 'non profit', label: 'Non Profit' },
  ];

  const customStyles = {
    control: (base) => ({
      ...base,
      height: 48,
      color: '#321b6d',
      fontWeight: '400',
    }),
    singleValue: (provided) => ({
      ...provided,
      color: '#321b6d',
    }),
    menu: (provided) => ({
      ...provided,
    }),
  };

  const handleRelationshipChange = (selection) => {
    setPartnerType(selection.value);
  };


  const onSchoolSubmit = handleSubmit((data) => {
    setIsLoading(true);
    const params = getValues();
    if (params['schoolType'] === "school") {
      let data = {
        school_details: {
          email: params['email'],
          password: params['password'],
          school_name: params['name'],
        },
        teacher_details: {
          first_name: params['first_name'],
          last_name: params['last_name'],
          profile: {
            mobile_number: ""
          }
        }
      }

      schoolViewModel
        .createSchool(data)
        .then((res) => {
          setUser(res)
          history.push({
            pathname: `${CAMP}/check-email`,
            state: { email: data.school_details.email },
          });
        }).catch((err) => {
          console.log(err);
          if (err.resultCode !== 40500)
            displayFormErrorsFromApi(err, setError);
          setIsDisabled(true);
          setIsLoading(false);
          setShow(false);
        });
    }
  });

  const onPartnerSubmit = handleSubmit((e) => {
    const params = getValues();
    setIsLoading(true);
    let data = {
      email: params['email'],
      password: params['password'],
      name_of_organisation: params['name'],
      type_of_organisation: params['organizationType'],
      first_name: params['first_name'],
      last_name: params['last_name'],
    }

    partnerViewModel
      .createPartner(data)
      .then((res) => {
        setUser(res)
        history.push({
          pathname: `${PARTNER_ROUTE}/check-email`,
          state: { email: data.email },
        });
        window.scrollTo(0, 0);
      }).catch((err) => {
        // console.log(err);
        if (err.resultCode !== 40500)
          displayFormErrorsFromApi(err, setError);
        setIsDisabled(true);
        setIsLoading(false);
        setShow(false);
      });
  })

  const onExpertSubmit = handleSubmit((e) => {
    const params = getValues();
    setIsLoading(true);
    let data = {
      email: params['email'],
      password: params['password'],
      first_name: params['first_name'],
      last_name: params['last_name'],
    }

    partnerViewModel
      .createExpert(data)
      .then((res) => {
        setUser(res)
        // history.push({
        //   pathname: `${PARTNER_ROUTE}/check_email`,
        //   state: { email: data.email },
        // });
        history.push(MY_PARTNER_ROUTE);
        window.scrollTo(0, 0);
      }).catch((err) => {
        // console.log(err);
        if (err.resultCode !== 40500)
          displayFormErrorsFromApi(err, setError);
        setIsDisabled(true);
        setIsLoading(false);
        setShow(false);
      });
  })

  useEffect(() => {
    changeBodyClassName([bg.GRADIENT]);
    window.scrollTo(0, 0);

    //* Append Google reCAPTCHA Enterprise script
    // const script = document.createElement('script');
    // script.src = 'https://www.google.com/recaptcha/enterprise.js';
    // script.async = true;
    // script.defer = true;
    // document.body.appendChild(script);

    // return () => {
    //   document.body.removeChild(script);
    // };
  }, []);

  return (
    <div className='sign-up-wrapper partner-signup-wrapper partner-sign-up'>
      <EmptyHeader />
      <Container className="onboarding-container" fluid="md">
        <Row className="content-wrapper">
          <Col className="content">
            <Form>
              <div className="progress-bar-wrapper">
                <ProgressBar now={100} />
              </div>
              <div className="title">
                Join our movement
                <br />
                Our stars are the creative kids who shape TaleTree Village
              </div>
              <div className="thin-border-line"></div>
              <div className="sub title">
                <div className="secondSection">
                  Join our vibrant community of young creators,
                  supported by mentors, educators, and global organizations.
                  Together, we're building a brighter future.
                </div>
              </div>
              <div className="input-wrapper">
                <div
                  className={`error-message-wrapper ${errShow ? 'show' : 'hide'}`}
                >
                  {errMessage}
                </div>
                <Form.Row>
                  <Form.Group className="container-fluid">
                    <FormLabel>
                      Are you a<span>*</span>
                    </FormLabel>
                    <Select
                      options={options}
                      styles={customStyles}
                      theme={(theme) => ({
                        ...theme,
                        borderRadius: '6px',
                        colors: {
                          ...theme.colors,
                          primary: '#80e4e1',
                        },
                      })}
                      onChange={handleRelationshipChange}
                    />
                    <input
                      type="hidden"
                      name="schoolType"
                      value={partnerType}
                      ref={register({
                        required:
                          partnerSignUpErrors.schoolType.required,
                      })}
                    />
                    <ErrorMessage
                      errors={errors}
                      name="schoolType"
                      className="small text-danger"
                      as="label"
                    />
                  </Form.Group>
                </Form.Row>
              </div>
            </Form>
            {/* For School */}
            {partnerType === "school" &&
              <Form onSubmit={onSchoolSubmit}>
                <div className="input-wrapper">
                  <Form.Row>
                    <Form.Group className="container-fluid">
                      <FormLabel>
                        Name of institution<span>*</span>
                      </FormLabel>
                      <FormInput
                        className="signup-input"
                        name="name"
                        placeholder="Enter your institution name"
                        data-testid="name"
                        ref={register({
                          required: partnerSignUpErrors.name.required,
                        })}
                      />
                      <ErrorMessage
                        errors={errors}
                        name="name"
                        className="small text-danger"
                        as="label"
                      />
                    </Form.Group>
                  </Form.Row>
                  <Form.Row>
                    <Form.Group className="container-fluid">
                      <FormLabel>
                        First name<span>*</span>
                      </FormLabel>
                      <FormInput
                        className="signup-input"
                        name="first_name"
                        placeholder="First name"
                        data-testid="first_name"
                        ref={register({
                          required: partnerSignUpErrors.first_name.required,
                        })}
                      />
                      <ErrorMessage
                        errors={errors}
                        name="first_name"
                        className="small text-danger"
                        as="label"
                      />
                    </Form.Group>
                    <Form.Group className="container-fluid">
                      <FormLabel>
                        Last name<span>*</span>
                      </FormLabel>
                      <FormInput
                        className="signup-input"
                        name="last_name"
                        placeholder="Last name"
                        data-testid="last_name"
                        ref={register({
                          required: partnerSignUpErrors.last_name.required,
                        })}
                      />
                      <ErrorMessage
                        errors={errors}
                        name="last_name"
                        className="small text-danger"
                        as="label"
                      />
                    </Form.Group>
                  </Form.Row>

                  <Form.Row>
                    <Form.Group className="container-fluid">
                      <FormLabel>
                        E-mail<span>*</span>
                      </FormLabel>
                      <FormInput
                        className="signup-input"
                        name="email"
                        placeholder="Your e-mail"
                        data-testid="email"
                        ref={register({
                          required: partnerSignUpErrors.email.required,
                          validate: (input) =>
                            isEmail(input) || partnerSignUpErrors.email.invalid,
                        })}
                      />
                      <ErrorMessage
                        errors={errors}
                        name="email"
                        className="small text-danger"
                        as="label"
                      />
                    </Form.Group>
                  </Form.Row>
                  <Form.Row>
                    <Form.Group className="container-fluid">
                      <FormLabel>
                        Password<span>*</span>
                      </FormLabel>
                      <FormPasswordInput
                        name="password"
                        placeholder="At least 8 characters"
                        data-testid="password"
                        ref={register({
                          required: partnerSignUpErrors.password.required,
                          minLength: {
                            value: 8,
                            message: partnerSignUpErrors.password.minLength,
                          },
                          validate: (value) =>
                            passwordStrengthValidator(value) ||
                            partnerSignUpErrors.password.strength,
                        })}
                      />
                      <ErrorMessage
                        errors={errors}
                        name="password"
                        className="small text-danger"
                        as="label"
                      />
                    </Form.Group>
                  </Form.Row>
                  <Form.Row>
                    <Form.Group className="container-fluid">
                      <FormLabel>
                        Confirm Password<span>*</span>
                      </FormLabel>
                      <FormPasswordInput
                        name="confirm_password"
                        placeholder="Confirm password"
                        data-testid="confirm_password"
                        ref={register({
                          required: partnerSignUpErrors.password.confirm,
                          validate: (value) =>
                            value === watch('password') ||
                            partnerSignUpErrors.password.mismatch,
                        })}
                      />
                      <ErrorMessage
                        errors={errors}
                        name="confirm_password"
                        className="small text-danger"
                        as="label"
                      />
                    </Form.Group>
                  </Form.Row>
                  <Form.Row>
                    <Form.Group className="container-fluid">
                      <div
                        className="g-recaptcha"
                        data-sitekey={grecaptchakey}
                        data-callback="verifyCallback"
                      ></div>
                    </Form.Group>
                  </Form.Row>
                </div>
                <div className="extra-description">
                  By clicking on Create Account, you agree to TaleTree’s{' '}
                  <a
                    className="text-primary"
                    href="https://www.taletree.app/terms-of-service"
                    target="_blank"
                  >
                    Terms of Service
                  </a>{' '}
                  and the{' '}
                  <a
                    className="text-primary"
                    href="https://www.taletree.app/privacy-policy"
                    target="_blank"
                  >
                    Privacy Policy
                  </a>
                </div>
                <div className="button-wrapper">
                  <Form.Group className="container-fluid">
                    <LoadButton
                      className="signup-btn gred-btn"
                      text="Complete account"
                      //isDisabled={isDisabled}
                      isLoading={isLoading}
                      testid="submit"
                    />
                  </Form.Group>
                </div>
              </Form>
            }
            {/* For Partner */}
            {partnerType === "partner" &&
              <Form onSubmit={onPartnerSubmit}>
                <div className="input-wrapper">
                  <Form.Row>
                    <Form.Group className="container-fluid">
                      <FormLabel>
                        Type of organisation<span>*</span>
                      </FormLabel>
                      <Select
                        options={partnerOptions}
                        styles={customStyles}
                        theme={(theme) => ({
                          ...theme,
                          borderRadius: '6px',
                          colors: {
                            ...theme.colors,
                            primary: '#80e4e1',
                          },
                        })}
                        onChange={(e) => setOrganizationType(e.value)}
                      />
                      <input
                        type="hidden"
                        name="organizationType"
                        value={organizationType}
                        ref={register({
                          required:
                            partnerSignUpErrors.organizationType.required,
                        })}
                      />
                      <ErrorMessage
                        errors={errors}
                        name="organizationType"
                        className="small text-danger"
                        as="label"
                      />
                    </Form.Group>
                  </Form.Row>
                  <Form.Row>
                    <Form.Group className="container-fluid">
                      <FormLabel>
                        Name of organisation<span>*</span>
                      </FormLabel>
                      <FormInput
                        className="signup-input"
                        name="name"
                        placeholder="Enter your institution name"
                        data-testid="name"
                        ref={register({
                          required: partnerSignUpErrors.name.required,
                        })}
                      />
                      <ErrorMessage
                        errors={errors}
                        name="name"
                        className="small text-danger"
                        as="label"
                      />
                    </Form.Group>
                  </Form.Row>
                  <Form.Row>
                    <Form.Group className="container-fluid">
                      <FormLabel>
                        First name<span>*</span>
                      </FormLabel>
                      <FormInput
                        className="signup-input"
                        name="first_name"
                        placeholder="First name"
                        data-testid="first_name"
                        ref={register({
                          required: partnerSignUpErrors.first_name.required,
                        })}
                      />
                      <ErrorMessage
                        errors={errors}
                        name="first_name"
                        className="small text-danger"
                        as="label"
                      />
                    </Form.Group>
                    <Form.Group className="container-fluid">
                      <FormLabel>
                        Last name<span>*</span>
                      </FormLabel>
                      <FormInput
                        className="signup-input"
                        name="last_name"
                        placeholder="Last name"
                        data-testid="last_name"
                        ref={register({
                          required: partnerSignUpErrors.last_name.required,
                        })}
                      />
                      <ErrorMessage
                        errors={errors}
                        name="last_name"
                        className="small text-danger"
                        as="label"
                      />
                    </Form.Group>
                  </Form.Row>

                  <Form.Row>
                    <Form.Group className="container-fluid">
                      <FormLabel>
                        E-mail<span>*</span>
                      </FormLabel>
                      <FormInput
                        className="signup-input"
                        name="email"
                        placeholder="Your e-mail"
                        data-testid="email"
                        ref={register({
                          required: partnerSignUpErrors.email.required,
                          validate: (input) =>
                            isEmail(input) || partnerSignUpErrors.email.invalid,
                        })}
                      />
                      <ErrorMessage
                        errors={errors}
                        name="email"
                        className="small text-danger"
                        as="label"
                      />
                    </Form.Group>
                  </Form.Row>
                  <Form.Row>
                    <Form.Group className="container-fluid">
                      <FormLabel>
                        Password<span>*</span>
                      </FormLabel>
                      <FormPasswordInput
                        name="password"
                        placeholder="At least 8 characters"
                        data-testid="password"
                        ref={register({
                          required: partnerSignUpErrors.password.required,
                          minLength: {
                            value: 8,
                            message: partnerSignUpErrors.password.minLength,
                          },
                          validate: (value) =>
                            passwordStrengthValidator(value) ||
                            partnerSignUpErrors.password.strength,
                        })}
                      />
                      <ErrorMessage
                        errors={errors}
                        name="password"
                        className="small text-danger"
                        as="label"
                      />
                    </Form.Group>
                  </Form.Row>
                  <Form.Row>
                    <Form.Group className="container-fluid">
                      <FormLabel>
                        Confirm Password<span>*</span>
                      </FormLabel>
                      <FormPasswordInput
                        name="confirm_password"
                        placeholder="Confirm password"
                        data-testid="confirm_password"
                        ref={register({
                          required: partnerSignUpErrors.password.confirm,
                          validate: (value) =>
                            value === watch('password') ||
                            partnerSignUpErrors.password.mismatch,
                        })}
                      />
                      <ErrorMessage
                        errors={errors}
                        name="confirm_password"
                        className="small text-danger"
                        as="label"
                      />
                    </Form.Group>
                  </Form.Row>
                  <Form.Row>
                    <Form.Group className="container-fluid">
                      <div
                        className="g-recaptcha"
                        data-sitekey={grecaptchakey}
                        data-callback="verifyCallback"
                      ></div>
                    </Form.Group>
                  </Form.Row>
                </div>
                <div className="extra-description">
                  By clicking on Create Account, you agree to TaleTree’s{' '}
                  <a
                    className="text-primary"
                    href="https://www.taletree.app/terms-of-service"
                    target="_blank"
                  >
                    Terms of Service
                  </a>{' '}
                  and the{' '}
                  <a
                    className="text-primary"
                    href="https://www.taletree.app/privacy-policy"
                    target="_blank"
                  >
                    Privacy Policy
                  </a>
                </div>
                <div className="button-wrapper">
                  <Form.Group className="container-fluid">
                    <LoadButton
                      className="signup-btn gred-btn"
                      text="Complete account"
                      //isDisabled={isDisabled}
                      isLoading={isLoading}
                      testid="submit"
                    />
                  </Form.Group>
                </div>
              </Form>
            }
            {partnerType === "expert" &&
              <Form onSubmit={onExpertSubmit}>
                <div className="input-wrapper">
                  <Form.Row>
                    <Form.Group className="container-fluid">
                      <FormLabel>
                        First name<span>*</span>
                      </FormLabel>
                      <FormInput
                        className="signup-input"
                        name="first_name"
                        placeholder="First name"
                        data-testid="first_name"
                        ref={register({
                          required: partnerSignUpErrors.first_name.required,
                        })}
                      />
                      <ErrorMessage
                        errors={errors}
                        name="first_name"
                        className="small text-danger"
                        as="label"
                      />
                    </Form.Group>
                    <Form.Group className="container-fluid">
                      <FormLabel>
                        Last name<span>*</span>
                      </FormLabel>
                      <FormInput
                        className="signup-input"
                        name="last_name"
                        placeholder="Last name"
                        data-testid="last_name"
                        ref={register({
                          required: partnerSignUpErrors.last_name.required,
                        })}
                      />
                      <ErrorMessage
                        errors={errors}
                        name="last_name"
                        className="small text-danger"
                        as="label"
                      />
                    </Form.Group>
                  </Form.Row>

                  <Form.Row>
                    <Form.Group className="container-fluid">
                      <FormLabel>
                        E-mail<span>*</span>
                      </FormLabel>
                      <FormInput
                        className="signup-input"
                        name="email"
                        placeholder="Your e-mail"
                        data-testid="email"
                        ref={register({
                          required: partnerSignUpErrors.email.required,
                          validate: (input) =>
                            isEmail(input) || partnerSignUpErrors.email.invalid,
                        })}
                      />
                      <ErrorMessage
                        errors={errors}
                        name="email"
                        className="small text-danger"
                        as="label"
                      />
                    </Form.Group>
                  </Form.Row>
                  <Form.Row>
                    <Form.Group className="container-fluid">
                      <FormLabel>
                        Password<span>*</span>
                      </FormLabel>
                      <FormPasswordInput
                        name="password"
                        placeholder="At least 8 characters"
                        data-testid="password"
                        ref={register({
                          required: partnerSignUpErrors.password.required,
                          minLength: {
                            value: 8,
                            message: partnerSignUpErrors.password.minLength,
                          },
                          validate: (value) =>
                            passwordStrengthValidator(value) ||
                            partnerSignUpErrors.password.strength,
                        })}
                      />
                      <ErrorMessage
                        errors={errors}
                        name="password"
                        className="small text-danger"
                        as="label"
                      />
                    </Form.Group>
                  </Form.Row>
                  <Form.Row>
                    <Form.Group className="container-fluid">
                      <FormLabel>
                        Confirm Password<span>*</span>
                      </FormLabel>
                      <FormPasswordInput
                        name="confirm_password"
                        placeholder="Confirm password"
                        data-testid="confirm_password"
                        ref={register({
                          required: partnerSignUpErrors.password.confirm,
                          validate: (value) =>
                            value === watch('password') ||
                            partnerSignUpErrors.password.mismatch,
                        })}
                      />
                      <ErrorMessage
                        errors={errors}
                        name="confirm_password"
                        className="small text-danger"
                        as="label"
                      />
                    </Form.Group>
                  </Form.Row>
                  <Form.Row>
                    <Form.Group className="container-fluid">
                      <div
                        className="g-recaptcha"
                        data-sitekey={grecaptchakey}
                        data-callback="verifyCallback"
                      ></div>
                    </Form.Group>
                  </Form.Row>
                </div>
                <div className="extra-description">
                  By clicking on Create Account, you agree to TaleTree’s{' '}
                  <a
                    className="text-primary"
                    href="https://www.taletree.app/terms-of-service"
                    target="_blank"
                  >
                    Terms of Service
                  </a>{' '}
                  and the{' '}
                  <a
                    className="text-primary"
                    href="https://www.taletree.app/privacy-policy"
                    target="_blank"
                  >
                    Privacy Policy
                  </a>
                </div>
                <div className="button-wrapper">
                  <Form.Group className="container-fluid">
                    <LoadButton
                      className="signup-btn gred-btn"
                      text="Complete account"
                      //isDisabled={isDisabled}
                      isLoading={isLoading}
                      testid="submit"
                    />
                  </Form.Group>
                </div>
              </Form>
            }
          </Col>
        </Row>
        <Row className="dont-have-acc">
          Already have an account? <Link to={PARTNER_LOGIN}> Login here </Link>
        </Row>
      </Container>
    </div>
  );
};

export default PartnerSignUp;